import { MESSAGE_ACTIONS, MESSAGE_KEY } from '../constants/TourMessageConstants';
const subscribeToTourEvent = (callback, listenedAction) => {
  const handler = event => {
    const {
      key,
      action,
      tourId
    } = event.data;
    if (key === MESSAGE_KEY && action === listenedAction) {
      callback(tourId);
    }
  };
  window.addEventListener('message', handler, false);
  return () => window.removeEventListener('message', handler, false);
};
export const subscribeToTourCompletion = callback => {
  return subscribeToTourEvent(callback, MESSAGE_ACTIONS.TOUR_COMPLETED);
};
export const subscribeToTourClose = callback => {
  return subscribeToTourEvent(callback, MESSAGE_ACTIONS.CLOSE);
};